module.exports = __webpack_public_path__ + "img/ill_1.d843540d.png";